<template>
	<div class="flexContainer" id="contentBrowser">
		<div class="navBox">
			<div class="navHeader"/>
			<div class="navItemContainer">
				<div class="navItem"
					 :class="{ navItemActive: selectedNavItem === navItem}"
					 v-for="(navItem, index) in navItems"
					 :key="index"
					 v-on:click="filterContent(navItem)">
					{{ navItem }}
				</div>
				<SearchBar class="searchBar" placeholder="Inhalte durchsuchen"/>
			</div>
			<div v-if="isEditable" class="editTags" v-on:click="editTags">+ Tags bearbeiten</div>
		</div>
		<div class="contentBoxLeft">
			<div class="title">Modell-Projektion</div>
			<ContentList v-bind:contentList="filteredModelList"
						 contentType="model"
						 v-bind:editable="isEditable"
						 v-bind:draggable="isDraggable"/>
		</div>
		<div class="contentBoxRight">
			<div class="title">Wand-Projektion</div>
			<ContentList v-bind:contentList="filteredWallList"
						 contentType="wall"
						 v-bind:editable="isEditable"
						 v-bind:draggable="isDraggable"/>
		</div>
	</div>
</template>

<script>
	import ContentList from '@/components/content/ContentList.vue';
	import SearchBar from '@/components/SearchBar.vue';
	import ContentLoader from '@/services/ContentLoader.js'
	import {EventBus} from '@/services/EventBus.js';


	export default {
		name: "ContentBrowser",
		components: {
			ContentList,
			SearchBar
		},
		props: {
			isEditable: Boolean,
			isDraggable: Boolean
		},
		data() {
			return {
				filteredModelList: [],
				filteredWallList: [],
				slideModelList: [],
				slideWallList: [],
				filterAll: 'Alle Tags',
				filterNoTag: 'Inhalte ohne Tag',
				filterUnused: 'Unbenutzte Inhalte',
				navItems: [],
				selectedNavItem: ''
			}
		},
		methods: {
			editTags() {
				EventBus.$emit('onEditTags');
			},
			searchForContent(query) {
				//console.log("search content for query: "+query);
				this.selectedNavItem = this.filterAll;
				this.filteredModelList = this.slideModelList.filter(slide => {
					return this.queryFoundInSlide(query, slide);
				});
				this.filteredWallList = this.slideWallList.filter(slide => {
					return this.queryFoundInSlide(query, slide);
				});
			},
			queryFoundInSlide(query, slide) {
				//search in title, text, filename, extension:
				return (slide.title.toLowerCase().search(query) >= 0) || (slide.text.toLowerCase().search(query) >= 0) || (slide.media.name.toLowerCase().search(query) >= 0) || (slide.media.ext.toLowerCase().search(query) >= 0);
			},
			filterContent(tagName) {
				//console.log("filter content for tag: "+tagName);
				this.selectedNavItem = tagName;
				this.filteredModelList = [];
				this.filteredWallList = [];
				if (tagName === this.filterAll) {
					this.filteredModelList = this.slideModelList;
					this.filteredWallList = this.slideWallList;
				} else if (tagName === this.filterNoTag) {
					this.filteredModelList = this.slideModelList.filter(slide => {
						return slide.tags.length == 0;
					});
					this.filteredWallList = this.slideWallList.filter(slide => {
						return slide.tags.length == 0;
					});
				} else if (tagName === this.filterUnused) {
					this.filteredModelList = this.slideModelList.filter(slide => {
						return slide.steps.length == 0;
					});
					this.filteredWallList = this.slideWallList.filter(slide => {
						return slide.steps.length == 0;
					});
				} else {
					this.slideModelList.forEach(slide => {
						slide.tags.forEach(tag => {
							if (tag.name === tagName) this.filteredModelList.push(slide);
						});
					});
					this.slideWallList.forEach(slide => {
						slide.tags.forEach(tag => {
							if (tag.name === tagName) this.filteredWallList.push(slide);
						});
					});
				}
				this.filteredModelList.sort((slide1, slide2) => slide1.title.localeCompare(slide2.title));
				this.filteredWallList.sort((slide1, slide2) => slide1.title.localeCompare(slide2.title));
			},
			async loadTags() {
				this.navItems = [];
				this.navItems.push(this.filterAll);
				var tags = await ContentLoader.loadTags();
				tags.forEach(tag => {
					this.navItems.push(tag.name);
				});
				this.navItems.push(this.filterNoTag);
				this.navItems.push(this.filterUnused);
				this.selectedNavItem = this.filterAll;
			},
			async loadContent() {
				this.slideModelList = await ContentLoader.loadSlides(ContentLoader.MODEL);
				this.slideWallList = await ContentLoader.loadSlides(ContentLoader.WALL);
				this.filterContent(this.selectedNavItem);
			},
			async updateSlide(slide) {
				await ContentLoader.update(slide);
			},
			async deleteSlide(slide) {
				await ContentLoader.deleteSlide(slide);
				this.loadContent();
			}
		},
		async created() {
			await this.loadTags();
			await this.loadContent();

			EventBus.$on('onSearch', queryString => {
				this.searchForContent(queryString);
			});
			EventBus.$on('onDeleteSearch', e => {
				console.log(e);
				this.filterContent(this.filterAll);
			});
			EventBus.$on('onDeleteSlide', slide => {
				//console.log("delete slide with id "+slide.id);
				this.deleteSlide(slide);
			});
			EventBus.$on('onUpdateSlide', slide => {
				//console.log("update slide with id "+slide.id);
				this.updateSlide(slide);
				this.filterContent(this.selectedNavItem);
			});
			EventBus.$on('onNewSlideCreated', type => {
				console.log("new slide created for type = " + type);
				this.loadContent();
			});
			EventBus.$on('onUpdateTags', tagsWereUpdated => {
				if(tagsWereUpdated) this.loadTags();
			});
		}
	}
</script>

<style scoped>

	#contentBrowser {
		min-height: 120px;
	}

	.title {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-weight: normal;
		font-size: 20px;
		border-bottom: black solid 1px;
		padding: 5px 10px 5px 10px;
	}

	.navItemContainer {
		overflow-y: auto;
	}

	.navHeader {
		height: 39px;
		min-height: 39px;
		border-bottom: black solid 1px;
		margin-bottom: 25px;
	}

	.editTags {
		font-size: 20px;
		margin: 10px 10px 10px 40px;
		color: #0088FF;
	}
	.editTags:hover {
		cursor: pointer;
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
	}
</style>